/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;

//##################
/* PHOTO TILES */
//##################
// Presumably this could be used by any service to display photos or albums in
// a tiled layout. Only Facebook uses it right now though.

window.PhotoTiles = {
	title: "",
	service: "",
	tiles: [],

	// Stub functions
	loadMore: null,

	init() {
		if (this.initialized) {
			return;
		}

		this.photoTilesContainer = $("#okphotos_photo_tiles");
		this.actionContent = this.photoTilesContainer.find(".action_content");
		this.header = $("#photo_tiles_header");
		this.headerTitle = this.header.find(".title");
		this.headerSubtitle = this.header.find(".subtitle");
		this.tileHolder = $("#photo_tile_holder");
		this.subtileHolder = $("#photo_subtile_holder");
		this.submitBtn = $("#photo_tiles_done");

		// Go back up to main tiles if you click on the title in subtiles
		this.headerSubtitle.on("click tap", () => {
			if (this.photoTilesContainer.hasClass("show_subtiles")) {
				this.hideSubtiles();
			}
		});

		// Fire the scroll callback, if available, when we hit the bottom of the
		// photo tiles.
		this.actionContent.on("scroll", () => {
			if (
				OkPhotos.currentActionName === "photo_tiles" &&
				this.scrollCallback &&
				!this.endOfTiles
			) {
				let distFromBottom =
					this.actionContent[0].scrollHeight -
					this.actionContent.scrollTop() -
					this.actionContent.height();
				if (!this.loading && distFromBottom < 300) {
					this.showLoader();
					this.scrollCallback();
				}
			}
		});

		// Submit on clicking the done button
		this.submitBtn.on("click tap", () => {
			if (!this.selectedTile) {
				return;
			}

			OkPhotos.showLoader();

			PhotoUtil.uploadUrl({
				url: this.selectedTile.source,

				success: r => {
					PhotoUploader.upload_cb(r);
				},

				error: r => {
					OkPhotos.showError();
				},

				complete: () => {
					OkPhotos.hideLoader();
				},
			});
		});

		this.initialized = true;
	},

	showLoader() {
		this.loading = true;
		this.photoTilesContainer.addClass("loading");
	},

	hideLoader() {
		this.loading = false;
		this.photoTilesContainer.removeClass("loading");
	},

	// Main function for using PhotoTiles, load in some tiles and display them.
	// See the @ vars used and addTile for more info about what to pass in.
	loadTileSet(params) {
		// Clean out the old tiles, if there were any.
		this.tileHolder.html("");
		this.hideSubtiles();

		$.extend(this, params);
		if (!this.tiles || !this.tiles.length) {
			OkPhotos.showError(PhotoUtil.ERRORS.NO_PHOTOS);
			return false;
		}

		if (this.title) {
			this.headerTitle.html(this.title);
		}

		for (let tile of this.tiles) {
			this.addTile(tile);
		}

		// In case their viewport is too big, fire off a fake scroll event after a
		// sec in case a scroll handler is bound.
		setTimeout(() => {
			this.actionContent.trigger("scroll");
		}, 100);
	},

	// Performs a similar action to loadTileset, but is a lot simpler. Pass in
	// a bunch of subtiles (See addTile for what those are) and a title for the
	// subtile set.
	loadSubtileSet(subtiles, title) {
		// Clean out old subtiles
		this.subtileHolder.html("");
		this.showSubtiles();

		if (!subtiles || !subtiles.length) {
			return false;
		}

		if (title) {
			this.headerSubtitle.html(title);
		} else {
			this.headerSubtitle.html("Back");
		}

		this.headerSubtitle.prepend('<i class="icon i-arrow-left"></i>');

		for (let tile of subtiles) {
			tile.subtile = true;
			this.addTile(tile);
		}

		// In case their viewport is too big, fire off a fake scroll event after a
		// sec in case a scroll handler is bound.
		setTimeout(() => {
			this.actionContent.trigger("scroll");
		}, 100);
	},

	showSubtiles() {
		if (this.showingSubtiles) {
			return;
		}

		this.showingSubtiles = true;
		this.photoTilesContainer.addClass("transitioning");

		setTimeout(() => {
			this.photoTilesContainer.addClass("show_subtiles");
			this.photoTilesContainer.removeClass("transitioning");
			this.actionContent.scrollTop(0);
			this.endOfTiles = false;
			OkPhotos.hideLoader();
		}, OkPhotos.animSpeed);
	},

	hideSubtiles() {
		if (!this.showingSubtiles) {
			return;
		}

		this.showingSubtiles = false;
		this.photoTilesContainer.addClass("transitioning");

		setTimeout(() => {
			// Clear content so it's not seen the next time a subtile page is loaded
			this.subtileHolder.html("");
			this.photoTilesContainer.removeClass("show_subtiles");
			this.photoTilesContainer.removeClass("transitioning");
			this.header.find(".subtitle").html("");
			this.actionContent.scrollTop(0);
			this.endOfTiles = false;
			OkPhotos.hideLoader();
		}, OkPhotos.animSpeed);
	},

	// A tile object consists of:
	//	id					(string) - unique identifier for the tile
	// classes	 (string) - Additional classes to add
	//	title	   (string) - Title for display
	//	description (string) - Description for display
	//	thumb	   (string) - Thumbnail for the image tile
	//	source	  (string) - The high quality source of the image file
	//	subtile	   (bool) - Whether or not this is a subtile
	//	onclick   (function) - Optional function to call on clicking the tile.
	//						If not specified, uses the image param for upload.
	//
	// Alternatively, you can pass a list of tiles.
	addTile(tile) {
		if (tile instanceof Array) {
			for (let singleTile of tile) {
				this.addTile(singleTile);
			}

			return;
		}

		let desc = "";
		let title = "";
		let classes = "photo_tile";

		if (tile.onclick) {
			classes += " no_radio";
		}

		if (tile.disabled) {
			classes += " disabled";
		}

		if (tile.title) {
			title = `<p class="title">${tile.title}</p>`;
		}

		if (tile.description) {
			desc = `<p class="desc">${tile.description}</p>`;
		}

		if (tile.classes) {
			classes = `${classes} ${tile.classes}`;
		}

		let tileEl = $(`\
<div id="${tile.id}" class="${classes}">
	<div class="image_container">
		<img/>
		<div class="radio">
			<i class="icon i-checkmark"/>
		</div>
	</div>
	${title}
	${desc}
</div>\
`);

		if (tile.subtile) {
			this.subtileHolder.append(tileEl);
		} else {
			this.tileHolder.append(tileEl);
		}

		let tileImg = tileEl.find("img");

		tileImg.on("load", () => {
			setTimeout(() => {
				tileImg.css("left", (tileEl.width() - tileImg.width) / 2);
				tileEl.addClass("loaded");
			}, parseInt(Math.random() * 200));
		});

		tileImg.on("error", () => {
			tileEl.addClass("loaded error");
			tileEl
				.find(".image_container")
				.append('<i class="icon i-photo-stack"/>');
		});

		// Fix the protocol. Images should only be from CDNs that support HTTPS.
		tileImg.attr(
			"src",
			tile.thumb.replace(/http(s)?\:/, window.location.protocol)
		);

		tileEl.bind("click tap", () => {
			if (tile.disabled) {
				return;
			}

			if (tile.onclick) {
				tile.onclick(tile);
			} else {
				let selected = tileEl.hasClass("selected");
				this.photoTilesContainer
					.find(".photo_tile.selected")
					.removeClass("selected");
				if (selected) {
					tileEl.removeClass("selected");
					this.submitBtn.addClass("disabled");
				} else {
					tileEl.addClass("selected");
					this.submitBtn.removeClass("disabled");
				}

				this.selectedTile = tile;
			}
		});
	},
};



// WEBPACK FOOTER //
// ./src/legacy/okphotos/phototiles.js